import { SessionProvider } from 'next-auth/react';
import { CartProvider } from '@context/CartContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useState, useEffect } from 'react';
import Preloader from '../components/common/Preloader';
import '../styles/globals.css';

export default function App({ Component, pageProps: { session, ...pageProps } }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time.  Replace with actual loading logic.
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1500); // Adjust the timeout as needed

    return () => clearTimeout(timeout);
  }, []);

  return (
    <SessionProvider session={session} clientMaxAge={300}>
      <CartProvider>
        <div className="flex flex-col min-h-screen">
          <Header />
          {loading ? (
            <Preloader />
          ) : (
            <main className="flex-grow">
              <Component {...pageProps} />
            </main>
          )}
          <Footer />
        </div>
      </CartProvider>
    </SessionProvider>
  );
}
